<div class="attendance-dialog">
  <header class="attendance-header">
    <div>
      <p class="attendance-header__group">Grupa: <strong>{{ data.lectureGroupName }}</strong></p>
      <h2 data-clarity-unmask="true">{{ view === 'days' ? 'Obecność na wykładach' : 'Lista obecności' }}</h2>
    </div>
    <button type="button" class="transparent-button" (click)="close()" aria-label="Zamknij" data-clarity-unmask="true">
      <i class="pi pi-times"></i>
    </button>
  </header>

  <!-- Lecture days of the group -->
  <ng-container *ngIf="view === 'days'">
    <p class="attendance-hint" data-clarity-unmask="true">
      Kursanci potwierdzają obecność, skanując w aplikacji kod QR ze stanowiska. Tu zaznaczysz tych, którzy nie mogli tego
      zrobić. Lista dnia powstaje sama, gdy rozpoczynasz wykłady na stanowisku.
    </p>

    <div class="attendance-toolbar">
      <button type="button" class="primary-button" (click)="openDay(today)" data-clarity-unmask="true">
        <i class="pi pi-calendar"></i> Dzisiejszy wykład
      </button>
      <button type="button" class="outlined-button" (click)="addingDay = !addingDay" data-clarity-unmask="true">
        <i class="pi pi-plus"></i> Wykład z innego dnia
      </button>
      <button
        *ngIf="anyRunning && canRunLectures"
        type="button"
        class="outlined-button"
        [disabled]="showingScreen"
        (click)="showOnStation(true)"
        data-testid="attendance-show-on-station"
        data-clarity-unmask="true"
      >
        <i class="pi pi-qrcode"></i> Pokaż kod QR na stanowisku
      </button>
    </div>

    <form *ngIf="addingDay" class="attendance-add" (ngSubmit)="addDay()">
      <label>
        <span>Dzień wykładu</span>
        <input pInputText type="date" name="newDay" [(ngModel)]="newDay" [max]="today" required />
      </label>
      <label class="attendance-add__topic">
        <span>Temat (opcjonalnie)</span>
        <input pInputText type="text" name="newTopic" [(ngModel)]="newTopic" maxlength="200" />
      </label>
      <button type="submit" class="primary-button" data-clarity-unmask="true">Otwórz listę</button>
    </form>

    <p-table [value]="days" [loading]="daysLoading" dataKey="guid" styleClass="attendance-days">
      <ng-template pTemplate="header">
        <tr>
          <th>Dzień</th>
          <th>Temat</th>
          <th class="col-count">Obecni</th>
          <th class="col-action"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-day>
        <tr class="attendance-day" (click)="openList(day)">
          <td>
            {{ formatDay(day.lectureDay) }}
            <p-tag *ngIf="day.isRunning" severity="success" value="trwa" styleClass="ml-2"></p-tag>
          </td>
          <td>{{ day.topic || '—' }}</td>
          <td class="col-count">{{ day.presentCount }} / {{ day.membersCount }}</td>
          <td class="col-action"><i class="pi pi-chevron-right"></i></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="attendance-empty">
            Nie ma jeszcze żadnej listy. Rozpocznij wykłady na stanowisku albo otwórz listę dzisiejszego wykładu.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <!-- One lecture day -->
  <ng-container *ngIf="view === 'list'">
    <p *ngIf="listLoading && !list" class="attendance-hint">Pobieranie listy obecności…</p>

    <ng-container *ngIf="list">
      <div class="attendance-summary">
        <div>
          <p class="attendance-summary__day">
            <span class="attendance-summary__date">{{ formatDay(list.lectureDay) }}</span>
            <p-tag
              *ngIf="list.isRunning"
              severity="success"
              value="wykład trwa – lista odświeża się sama"
              styleClass="ml-2"
            ></p-tag>
          </p>
          <label class="attendance-topic">
            <span>Temat</span>
            <input pInputText type="text" [(ngModel)]="topic" maxlength="200" placeholder="np. Zasady pierwszeństwa" />
          </label>
        </div>
        <div class="attendance-count" data-testid="attendance-count">
          <strong>{{ presentCount }}</strong> / {{ list.students.length }}
          <span>obecnych</span>
        </div>
      </div>

      <div class="attendance-toolbar">
        <button type="button" class="outlined-button" (click)="markAll(true)" data-clarity-unmask="true">
          <i class="pi pi-check-square"></i> Zaznacz wszystkich
        </button>
        <button type="button" class="outlined-button" (click)="markAll(false)" data-clarity-unmask="true">
          <i class="pi pi-stop"></i> Odznacz wszystkich
        </button>
        <ng-container *ngIf="list.canShowOnStation">
          <button
            type="button"
            class="outlined-button"
            [disabled]="showingScreen"
            (click)="showOnStation(true)"
            data-testid="attendance-show-on-station"
            data-clarity-unmask="true"
          >
            <i class="pi pi-qrcode"></i> Pokaż kod QR na stanowisku
          </button>
          <button
            type="button"
            class="secondary-button"
            [disabled]="showingScreen"
            (click)="showOnStation(false)"
            data-clarity-unmask="true"
          >
            Zamknij na stanowisku
          </button>
        </ng-container>
      </div>

      <p-table [value]="list.students" dataKey="studentGuid" styleClass="attendance-students" [scrollable]="true" scrollHeight="50vh">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-check">Obecny</th>
            <th>Kursant</th>
            <th>Potwierdzenie</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-student>
          <tr [class.is-changed]="isChanged(student)" [attr.data-testid]="'attendance-row-' + student.studentGuid">
            <td class="col-check">
              <p-checkbox
                [binary]="true"
                [ngModel]="isPresent(student)"
                (ngModelChange)="setPresent(student, $event)"
                [inputId]="'present-' + student.studentGuid"
              ></p-checkbox>
            </td>
            <td>
              <label class="student-name" [for]="'present-' + student.studentGuid">{{ student.displayName }}</label>
              <small class="student-email">{{ student.email }}</small>
              <p-tag *ngIf="!student.isMember" severity="warning" value="poza grupą" styleClass="ml-2"></p-tag>
            </td>
            <td class="col-source">
              <ng-container *ngIf="isChanged(student); else savedSource">
                <span class="source source--pending">niezapisane</span>
              </ng-container>
              <ng-template #savedSource>
                <ng-container [ngSwitch]="student.source">
                  <span *ngSwitchCase="Source.App" class="source source--app">
                    <i class="pi pi-mobile"></i> aplikacja, {{ markedAt(student) | date: 'HH:mm' }}
                  </span>
                  <span *ngSwitchCase="Source.Panel" class="source">
                    <i class="pi pi-user-edit"></i>
                    {{ student.isPresent ? 'zaznaczył(a)' : 'odznaczył(a)' }} {{ student.markedByName || 'personel' }},
                    {{ markedAt(student) | date: 'dd.MM HH:mm' }}
                  </span>
                  <span *ngSwitchDefault class="source source--none">—</span>
                </ng-container>
              </ng-template>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="attendance-empty">Grupa nie ma kursantów.</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="actions">
        <button type="button" class="cancel" (click)="backToDays()" data-clarity-unmask="true">
          <i class="pi pi-arrow-left"></i> Wszystkie wykłady
        </button>
        <button
          *ngIf="presentCount === 0 && !list.isRunning && !dirty"
          type="button"
          class="cancel"
          [disabled]="deleting"
          (click)="deleteList()"
          data-clarity-unmask="true"
        >
          Usuń pustą listę
        </button>
        <span class="actions__spacer"></span>
        <button type="button" class="confirm" [disabled]="!dirty || saving" (click)="save()" data-testid="attendance-save" data-clarity-unmask="true">
          {{ saving ? 'Zapisywanie…' : 'Zapisz' }}
        </button>
      </div>
    </ng-container>
  </ng-container>

  <p-confirmDialog key="lectureAttendanceConfirm"></p-confirmDialog>
</div>
